import React from "react";
import { SectionHeader } from "@/components/design-system/SectionHeader/SectionHeader";
import { ExperienceCard } from "@/components/design-system/ExperienceCard/ExperienceCard";
import { cards } from "./CreditUnionMemberExperienceSection.data";

export const CreditUnionMemberExperienceSection: React.FC = () => (
  <section className="bg-primary-700 w-full overflow-hidden">
    <div className="mx-auto max-w-360 px-5 py-16 md:px-8 md:py-24 lg:px-16">
      <div className="mb-12 md:mb-16">
        <SectionHeader
          label="Member Experience"
          heading="Conversational guidance based on the full picture."
          description="Replace static portals and generic articles with a conversational AI guide that knows each member's real financial picture — and surfaces the right product at the right moment."
          theme="dark"
        />
      </div>

      <div className="grid grid-cols-1 gap-6 md:grid-cols-4 xl:mx-auto xl:max-w-282">
        {cards.map((card) => (
          <ExperienceCard key={card.title} image={card.image} title={card.title} description={card.description} />
        ))}
      </div>
    </div>
  </section>
);
